import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import Loading from 'components/system/Loading'
import FormWrapper from 'components/form/Wrapper'

import selectors from 'store/selectors'
import settings from 'settings'

import clientActions from 'store/modules/client'
import networkActions from 'store/modules/network'
import routerActions from 'store/modules/router'

const {
  clientSchema,
} = settings

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(5),
  },
  button: {
    marginRight: theme.spacing(2),
  },
}))

const schema = clientSchema

const ClientEdit = ({
  
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const id = useSelector(selectors.router.idParam)
  const client = useSelector(selectors.client.collection.item) || {}
  const error = useSelector(selectors.client.errors.save)
  const submitting = useSelector(selectors.client.loading.save)
  const loading = useSelector(selectors.client.loading.get)

  const onSave = (id, values) => dispatch(clientActions.save(id, values))
  const onCancel = () => dispatch(routerActions.navigateTo('client.list'))
  const clearError = () => dispatch(networkActions.clearError('client.save'))

  useEffect(() => {
    clearError()
  }, [])

  if(loading) return <Loading />

  return (
    <div className={ classes.root }>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper className={ classes.paper }>
            <Typography variant="h6" gutterBottom>
              Client
            </Typography>
            <FormWrapper
              schema={ schema }
              initialValues={ client }
              error={ error }
              onSubmit={ (values) => onSave(id, values) }
              renderButtons={
                ({
                  handleSubmit,
                }) => {
                  return (
                    <React.Fragment>
                      <Button
                        className={ classes.button }
                        type="button"
                        variant="contained"
                        onClick={ onCancel }
                      >
                        Cancel
                      </Button>
                      <Button
                        className={ classes.button }
                        type="button"
                        variant="contained"
                        color="primary"
                        disabled={ submitting }
                        onClick={ handleSubmit }
                      >
                        Save
                      </Button>
                    </React.Fragment>
                  )
                }
              }
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}

export default ClientEdit